/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../public/upgrade/feature/carTemplate/list/car-template-list.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '../../../../../../public/upgrade/feature/carTemplate/car-template.service';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '@angular/http/src/http';
import * as import10 from '../../../../../../public/upgrade/root/modal/modal.service';
import * as import11 from '../../../../../../public/upgrade/root/loading/loading-wheel.service';
import * as import12 from '@angular/router/src/router';
import * as import13 from '@angular/router/src/router_state';
import * as import14 from '../../../../../../public/upgrade/core/session.service';
import * as import15 from '../../../../../../public/upgrade/root/toast/notification.service';
import * as import16 from '@angular/core/src/zone/ng_zone';
import * as import17 from '@ngx-translate/core/src/translate.pipe';
import * as import18 from '@angular/core/src/linker/view_container';
import * as import19 from '@angular/core/src/change_detection/change_detection_util';
import * as import20 from '@ngx-translate/core/src/translate.service';
import * as import21 from '../../../../../node_modules/@angular/forms/src/directives/select_control_value_accessor.ngfactory';
import * as import22 from '../../../../../node_modules/@angular/forms/src/directives/select_multiple_control_value_accessor.ngfactory';
import * as import23 from '@angular/core/src/linker/element_ref';
import * as import24 from '@angular/forms/src/directives/select_control_value_accessor';
import * as import25 from '@angular/forms/src/directives/select_multiple_control_value_accessor';
import * as import26 from '@angular/core/src/security';
import * as import27 from '../../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import28 from '@angular/core/src/linker/template_ref';
import * as import29 from '@angular/common/src/directives/ng_if';
import * as import30 from '../../../../../../public/upgrade/feature/carTemplate/list/card/car-template-list-card.component';
import * as import31 from './card/car-template-list-card.component.ngfactory';
import * as import32 from '../../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import33 from '../../../../../../public/upgrade/shared/pager/eva-pager.component';
import * as import34 from '../../../shared/pager/eva-pager.component.ngfactory';
import * as import35 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import36 from '@angular/common/src/directives/ng_for';
import * as import37 from '../../../../../node_modules/@angular/forms/src/directives/ng_model.ngfactory';
import * as import38 from '../../../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import39 from '@angular/forms/src/directives/control_value_accessor';
import * as import40 from '@angular/forms/src/directives/ng_model';
import * as import41 from '@angular/forms/src/directives/ng_control';
import * as import42 from '@angular/forms/src/directives/ng_control_status';
export class Wrapper_CarTemplateListComponent {
  /*private*/ _eventHandler:Function;
  context:import0.CarTemplateListComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any) {
    this._changed = false;
    this.context = new import0.CarTemplateListComponent(p0,p1,p2,p3,p4,p5,p6,p7);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_CarTemplateListComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_CarTemplateListComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.CarTemplateListComponent>;
  _CarTemplateService_0_3:import5.CarTemplateService;
  _CarTemplateListComponent_0_4:Wrapper_CarTemplateListComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_CarTemplateListComponent_Host0,renderType_CarTemplateListComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'car-template-list',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_CarTemplateListComponent0(this.viewUtils,this,0,this._el_0);
    this._CarTemplateService_0_3 = new import5.CarTemplateService(this.injectorGet(import9.Http,this.parentIndex));
    this._CarTemplateListComponent_0_4 = new Wrapper_CarTemplateListComponent(this.injectorGet(import10.ModalService,this.parentIndex),this.injectorGet(import11.LoadingWheelService,this.parentIndex),this.injectorGet(import12.Router,this.parentIndex),this.injectorGet(import13.ActivatedRoute,this.parentIndex),this.injectorGet(import14.SessionService,this.parentIndex),this._CarTemplateService_0_3,this.injectorGet(import15.NotificationService,this.parentIndex),this.injectorGet(import16.NgZone,this.parentIndex));
    this.compView_0.create(this._CarTemplateListComponent_0_4.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._CarTemplateListComponent_0_4.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import5.CarTemplateService) && (0 === requestNodeIndex))) { return this._CarTemplateService_0_3; }
    if (((token === import0.CarTemplateListComponent) && (0 === requestNodeIndex))) { return this._CarTemplateListComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._CarTemplateListComponent_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const CarTemplateListComponentNgFactory:import8.ComponentFactory<import0.CarTemplateListComponent> = new import8.ComponentFactory<import0.CarTemplateListComponent>('car-template-list',View_CarTemplateListComponent_Host0,import0.CarTemplateListComponent);
const styles_CarTemplateListComponent:any[] = ([] as any[]);
class View_CarTemplateListComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  /*private*/ _expr_13:any;
  _pipe_translate_0:import17.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import18.ViewContainer) {
    super(View_CarTemplateListComponent1,renderType_CarTemplateListComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_13 = import19.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','specialoffer-card-container eva-3-row -eva-3-mt-lg'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','specialoffer-card-create eva-3-card -eva-3-shadow-1-hover -eva-3-p-sm -card-outline'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','create-promo-img-container'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'img',new import3.InlineArray4(4,'class','create-promo-img','src','http://media.staticontent.com/media/pictures/674f3103-3050-46a1-9f52-7cf05a0d5b83'),(null as any));
    this._text_7 = this.renderer.createText(this._el_4,'\n                        ',(null as any));
    this._text_8 = this.renderer.createText(this._el_2,'\n                        ',(null as any));
    this._el_9 = import3.createRenderElement(this.renderer,this._el_2,'button',new import3.InlineArray4(4,'class','eva-3-btn-ghost -md -ghost -blue -eva-3-mt-lg','qadata','new-carTemplate'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'',(null as any));
    this._text_11 = this.renderer.createText(this._el_2,'\n                    ',(null as any));
    this._text_12 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_9,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_9));
    this._pipe_translate_0 = new import17.TranslatePipe(this.parentView.injectorGet(import20.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._text_12
    ]
    ),[disposable_0]);
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import19.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_13:any = import3.inlineInterpolate(1,'\n                            ',valUnwrapper.unwrap(this._pipe_translate_0.transform('carTemplate.NEW')),'\n                        ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_13,currVal_13))) {
      this.renderer.setText(this._text_10,currVal_13);
      this._expr_13 = currVal_13;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_9(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.add()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_CarTemplateListComponent2 extends import1.AppView<any> {
  _el_0:any;
  _NgSelectOption_0_3:import21.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_0_4:import22.Wrapper_NgSelectMultipleOption;
  _text_1:any;
  /*private*/ _expr_4:any;
  _pipe_translate_0:import17.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import18.ViewContainer) {
    super(View_CarTemplateListComponent2,renderType_CarTemplateListComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import19.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'option',new import3.InlineArray2(2,'class','select-option'),(null as any));
    this._NgSelectOption_0_3 = new import21.Wrapper_NgSelectOption(new import23.ElementRef(this._el_0),this.renderer,(<View_CarTemplateListComponent0>this.parentView)._SelectControlValueAccessor_39_3.context);
    this._NgSelectMultipleOption_0_4 = new import22.Wrapper_NgSelectMultipleOption(new import23.ElementRef(this._el_0),this.renderer,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import17.TranslatePipe(this.parentView.injectorGet(import20.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import24.NgSelectOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectOption_0_3.context; }
    if (((token === import25.NgSelectMultipleOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectMultipleOption_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import19.ValueUnwrapper();
    const currVal_0_0_0:any = this.context.$implicit;
    this._NgSelectOption_0_3.check_ngValue(currVal_0_0_0,throwOnChange,false);
    this._NgSelectOption_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_0_1_0:any = this.context.$implicit;
    this._NgSelectMultipleOption_0_4.check_ngValue(currVal_0_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    valUnwrapper.reset();
    const currVal_4:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(('carTemplate.approvalStatus.' + this.context.$implicit))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_4,currVal_4))) {
      this.renderer.setText(this._text_1,currVal_4);
      this._expr_4 = currVal_4;
    }
  }
  destroyInternal():void {
    this._NgSelectOption_0_3.ngOnDestroy();
    this._NgSelectMultipleOption_0_4.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_CarTemplateListComponent3 extends import1.AppView<any> {
  _el_0:any;
  _NgSelectOption_0_3:import21.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_0_4:import22.Wrapper_NgSelectMultipleOption;
  _text_1:any;
  /*private*/ _expr_4:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import18.ViewContainer) {
    super(View_CarTemplateListComponent3,renderType_CarTemplateListComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import19.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'option',new import3.InlineArray2(2,'class','select-option'),(null as any));
    this._NgSelectOption_0_3 = new import21.Wrapper_NgSelectOption(new import23.ElementRef(this._el_0),this.renderer,(<View_CarTemplateListComponent0>this.parentView)._SelectControlValueAccessor_56_3.context);
    this._NgSelectMultipleOption_0_4 = new import22.Wrapper_NgSelectMultipleOption(new import23.ElementRef(this._el_0),this.renderer,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import24.NgSelectOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectOption_0_3.context; }
    if (((token === import25.NgSelectMultipleOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectMultipleOption_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.context.$implicit;
    this._NgSelectOption_0_3.check_ngValue(currVal_0_0_0,throwOnChange,false);
    this._NgSelectOption_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_0_1_0:any = this.context.$implicit;
    this._NgSelectMultipleOption_0_4.check_ngValue(currVal_0_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_4:any = import3.inlineInterpolate(1,'',this.context.$implicit,'');
    if (import3.checkBinding(throwOnChange,this._expr_4,currVal_4)) {
      this.renderer.setText(this._text_1,currVal_4);
      this._expr_4 = currVal_4;
    }
  }
  destroyInternal():void {
    this._NgSelectOption_0_3.ngOnDestroy();
    this._NgSelectMultipleOption_0_4.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_CarTemplateListComponent4 extends import1.AppView<any> {
  _el_0:any;
  _NgSelectOption_0_3:import21.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_0_4:import22.Wrapper_NgSelectMultipleOption;
  _text_1:any;
  /*private*/ _expr_4:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import18.ViewContainer) {
    super(View_CarTemplateListComponent4,renderType_CarTemplateListComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import19.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'option',new import3.InlineArray2(2,'class','select-option'),(null as any));
    this._NgSelectOption_0_3 = new import21.Wrapper_NgSelectOption(new import23.ElementRef(this._el_0),this.renderer,(<View_CarTemplateListComponent0>this.parentView)._SelectControlValueAccessor_76_3.context);
    this._NgSelectMultipleOption_0_4 = new import22.Wrapper_NgSelectMultipleOption(new import23.ElementRef(this._el_0),this.renderer,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import24.NgSelectOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectOption_0_3.context; }
    if (((token === import25.NgSelectMultipleOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectMultipleOption_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.context.$implicit;
    this._NgSelectOption_0_3.check_ngValue(currVal_0_0_0,throwOnChange,false);
    this._NgSelectOption_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_0_1_0:any = this.context.$implicit;
    this._NgSelectMultipleOption_0_4.check_ngValue(currVal_0_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_4:any = import3.inlineInterpolate(1,'',this.context.$implicit,'');
    if (import3.checkBinding(throwOnChange,this._expr_4,currVal_4)) {
      this.renderer.setText(this._text_1,currVal_4);
      this._expr_4 = currVal_4;
    }
  }
  destroyInternal():void {
    this._NgSelectOption_0_3.ngOnDestroy();
    this._NgSelectMultipleOption_0_4.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_CarTemplateListComponent8 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _expr_1:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import18.ViewContainer) {
    super(View_CarTemplateListComponent8,renderType_CarTemplateListComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_1 = import19.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'img',new import3.InlineArray2(2,'loading','lazy'),(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_1:any = ((this.parentView.parentView.context.$implicit.carModel == null)? (null as any): this.parentView.parentView.context.$implicit.carModel.auxPicture.url);
    if (import3.checkBinding(throwOnChange,this._expr_1,currVal_1)) {
      this.renderer.setElementProperty(this._el_0,'src',this.viewUtils.sanitizer.sanitize(import26.SecurityContext.URL,currVal_1));
      this._expr_1 = currVal_1;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_CarTemplateListComponent7 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import18.ViewContainer;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import27.Wrapper_NgIf;
  _text_3:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import18.ViewContainer) {
    super(View_CarTemplateListComponent7,renderType_CarTemplateListComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','car-thumbnail-list'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import18.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import28.TemplateRef_(this,2,this._anchor_2);
    this._NgIf_2_6 = new import27.Wrapper_NgIf(this._vc_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText(this._el_0,'\n                                            ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import28.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import29.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:boolean = (!!((this.parentView.context.$implicit.carModel == null)? (null as any): this.parentView.context.$implicit.carModel.auxPicture) && ((this.parentView.context.$implicit.carModel == null)? (null as any): this.parentView.context.$implicit.carModel.auxPicture.url));
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 2)) { return new View_CarTemplateListComponent8(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    return (null as any);
  }
}
class View_CarTemplateListComponent10 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _expr_1:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import18.ViewContainer) {
    super(View_CarTemplateListComponent10,renderType_CarTemplateListComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_1 = import19.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'img',new import3.InlineArray2(2,'loading','lazy'),(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_1:any = ((this.parentView.parentView.context.$implicit.carModel == null)? (null as any): this.parentView.parentView.context.$implicit.carModel.picture.url);
    if (import3.checkBinding(throwOnChange,this._expr_1,currVal_1)) {
      this.renderer.setElementProperty(this._el_0,'src',this.viewUtils.sanitizer.sanitize(import26.SecurityContext.URL,currVal_1));
      this._expr_1 = currVal_1;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_CarTemplateListComponent9 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import18.ViewContainer;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import27.Wrapper_NgIf;
  _text_3:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import18.ViewContainer) {
    super(View_CarTemplateListComponent9,renderType_CarTemplateListComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','car-thumbnail-list'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                                ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import18.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import28.TemplateRef_(this,2,this._anchor_2);
    this._NgIf_2_6 = new import27.Wrapper_NgIf(this._vc_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText(this._el_0,'\n                                            ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import28.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import29.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:boolean = (!!((this.parentView.context.$implicit.carModel == null)? (null as any): this.parentView.context.$implicit.carModel.picture) && ((this.parentView.context.$implicit.carModel == null)? (null as any): this.parentView.context.$implicit.carModel.picture.url));
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 2)) { return new View_CarTemplateListComponent10(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    return (null as any);
  }
}
class View_CarTemplateListComponent6 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import1.AppView<import30.CarTemplateListCardComponent>;
  _CarTemplateListCardComponent_2_3:import31.Wrapper_CarTemplateListCardComponent;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _el_11:any;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _el_16:any;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  _el_20:any;
  _el_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _el_25:any;
  _el_26:any;
  _text_27:any;
  _text_28:any;
  _text_29:any;
  _text_30:any;
  _el_31:any;
  _text_32:any;
  _el_33:any;
  _el_34:any;
  _text_35:any;
  _text_36:any;
  _text_37:any;
  _el_38:any;
  _el_39:any;
  _text_40:any;
  _text_41:any;
  _text_42:any;
  _el_43:any;
  _el_44:any;
  _text_45:any;
  _text_46:any;
  _text_47:any;
  _el_48:any;
  _el_49:any;
  _text_50:any;
  _text_51:any;
  _text_52:any;
  _text_53:any;
  _el_54:any;
  _text_55:any;
  _anchor_56:any;
  /*private*/ _vc_56:import18.ViewContainer;
  _TemplateRef_56_5:any;
  _NgIf_56_6:import27.Wrapper_NgIf;
  _text_57:any;
  _anchor_58:any;
  /*private*/ _vc_58:import18.ViewContainer;
  _TemplateRef_58_5:any;
  _NgIf_58_6:import27.Wrapper_NgIf;
  _text_59:any;
  _text_60:any;
  _text_61:any;
  _text_62:any;
  _text_63:any;
  _map_72:any;
  /*private*/ _expr_73:any;
  _pipe_translate_0:import17.TranslatePipe;
  /*private*/ _expr_75:any;
  /*private*/ _expr_76:any;
  _pipe_translate_1:import17.TranslatePipe;
  /*private*/ _expr_78:any;
  /*private*/ _expr_79:any;
  _pipe_translate_2:import17.TranslatePipe;
  /*private*/ _expr_81:any;
  /*private*/ _expr_82:any;
  _pipe_translate_3:import17.TranslatePipe;
  /*private*/ _expr_84:any;
  /*private*/ _expr_85:any;
  _pipe_translate_4:import17.TranslatePipe;
  /*private*/ _expr_87:any;
  /*private*/ _expr_88:any;
  _pipe_translate_5:import17.TranslatePipe;
  /*private*/ _expr_90:any;
  /*private*/ _expr_91:any;
  _pipe_translate_6:import17.TranslatePipe;
  /*private*/ _expr_93:any;
  _pipe_translate_7:import17.TranslatePipe;
  /*private*/ _expr_95:any;
  _pipe_translate_8:import17.TranslatePipe;
  /*private*/ _expr_97:any;
  _pipe_translate_9:import17.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import18.ViewContainer) {
    super(View_CarTemplateListComponent6,renderType_CarTemplateListComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._map_72 = import3.pureProxy5((p0:any,p1:any,p2:any,p3:any,p4:any):{[key: string]:any} => {
      return {
        title: p0,
        status: p1,
        editable: p2,
        removable: p3,
        moderable: p4
      }
      ;
    });
    this._expr_73 = import19.UNINITIALIZED;
    this._expr_75 = import19.UNINITIALIZED;
    this._expr_76 = import19.UNINITIALIZED;
    this._expr_78 = import19.UNINITIALIZED;
    this._expr_79 = import19.UNINITIALIZED;
    this._expr_81 = import19.UNINITIALIZED;
    this._expr_82 = import19.UNINITIALIZED;
    this._expr_84 = import19.UNINITIALIZED;
    this._expr_85 = import19.UNINITIALIZED;
    this._expr_87 = import19.UNINITIALIZED;
    this._expr_88 = import19.UNINITIALIZED;
    this._expr_90 = import19.UNINITIALIZED;
    this._expr_91 = import19.UNINITIALIZED;
    this._expr_93 = import19.UNINITIALIZED;
    this._expr_95 = import19.UNINITIALIZED;
    this._expr_97 = import19.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'car-template-list-card',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import31.View_CarTemplateListCardComponent0(this.viewUtils,this,2,this._el_2);
    this._CarTemplateListCardComponent_2_3 = new import31.Wrapper_CarTemplateListCardComponent(this.compView_2.ref);
    this._text_3 = this.renderer.createText((null as any),'\n                                ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                                    ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                                        ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','-md-4'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                                            ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._el_11 = import3.createRenderElement(this.renderer,this._el_10,'span',new import3.InlineArray4(4,'class','car-label','qadata','brand'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'',(null as any));
    this._text_13 = this.renderer.createText(this._el_10,'',(null as any));
    this._text_14 = this.renderer.createText(this._el_8,'\n                                            ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_8,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._el_16 = import3.createRenderElement(this.renderer,this._el_15,'span',new import3.InlineArray4(4,'class','car-label','qadata','model'),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'',(null as any));
    this._text_18 = this.renderer.createText(this._el_15,'',(null as any));
    this._text_19 = this.renderer.createText(this._el_8,'\n                                            ',(null as any));
    this._el_20 = import3.createRenderElement(this.renderer,this._el_8,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,this._el_20,'span',new import3.InlineArray4(4,'class','car-label','qadata','category'),(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'',(null as any));
    this._text_23 = this.renderer.createText(this._el_20,'',(null as any));
    this._text_24 = this.renderer.createText(this._el_8,'\n                                            ',(null as any));
    this._el_25 = import3.createRenderElement(this.renderer,this._el_8,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._el_26 = import3.createRenderElement(this.renderer,this._el_25,'span',new import3.InlineArray4(4,'class','car-label','qadata','type'),(null as any));
    this._text_27 = this.renderer.createText(this._el_26,'',(null as any));
    this._text_28 = this.renderer.createText(this._el_25,'',(null as any));
    this._text_29 = this.renderer.createText(this._el_8,'\n                                        ',(null as any));
    this._text_30 = this.renderer.createText(this._el_6,'\n                                        ',(null as any));
    this._el_31 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','-md-4'),(null as any));
    this._text_32 = this.renderer.createText(this._el_31,'\n                                            ',(null as any));
    this._el_33 = import3.createRenderElement(this.renderer,this._el_31,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._el_34 = import3.createRenderElement(this.renderer,this._el_33,'span',new import3.InlineArray4(4,'class','car-label','qadata','doors'),(null as any));
    this._text_35 = this.renderer.createText(this._el_34,'',(null as any));
    this._text_36 = this.renderer.createText(this._el_33,'',(null as any));
    this._text_37 = this.renderer.createText(this._el_31,'\n                                            ',(null as any));
    this._el_38 = import3.createRenderElement(this.renderer,this._el_31,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._el_39 = import3.createRenderElement(this.renderer,this._el_38,'span',new import3.InlineArray4(4,'class','car-label','qadata','passengers'),(null as any));
    this._text_40 = this.renderer.createText(this._el_39,'',(null as any));
    this._text_41 = this.renderer.createText(this._el_38,'',(null as any));
    this._text_42 = this.renderer.createText(this._el_31,'\n                                            ',(null as any));
    this._el_43 = import3.createRenderElement(this.renderer,this._el_31,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._el_44 = import3.createRenderElement(this.renderer,this._el_43,'span',new import3.InlineArray4(4,'class','car-label','qadata','ac'),(null as any));
    this._text_45 = this.renderer.createText(this._el_44,'',(null as any));
    this._text_46 = this.renderer.createText(this._el_43,'',(null as any));
    this._text_47 = this.renderer.createText(this._el_31,'\n                                            ',(null as any));
    this._el_48 = import3.createRenderElement(this.renderer,this._el_31,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._el_49 = import3.createRenderElement(this.renderer,this._el_48,'span',new import3.InlineArray4(4,'class','car-label','qadata','transmission'),(null as any));
    this._text_50 = this.renderer.createText(this._el_49,'',(null as any));
    this._text_51 = this.renderer.createText(this._el_48,'',(null as any));
    this._text_52 = this.renderer.createText(this._el_31,'\n                                        ',(null as any));
    this._text_53 = this.renderer.createText(this._el_6,'\n                                        ',(null as any));
    this._el_54 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','-md-4'),(null as any));
    this._text_55 = this.renderer.createText(this._el_54,'\n                                            ',(null as any));
    this._anchor_56 = this.renderer.createTemplateAnchor(this._el_54,(null as any));
    this._vc_56 = new import18.ViewContainer(56,54,this,this._anchor_56);
    this._TemplateRef_56_5 = new import28.TemplateRef_(this,56,this._anchor_56);
    this._NgIf_56_6 = new import27.Wrapper_NgIf(this._vc_56.vcRef,this._TemplateRef_56_5);
    this._text_57 = this.renderer.createText(this._el_54,'\n                                            ',(null as any));
    this._anchor_58 = this.renderer.createTemplateAnchor(this._el_54,(null as any));
    this._vc_58 = new import18.ViewContainer(58,54,this,this._anchor_58);
    this._TemplateRef_58_5 = new import28.TemplateRef_(this,58,this._anchor_58);
    this._NgIf_58_6 = new import27.Wrapper_NgIf(this._vc_58.vcRef,this._TemplateRef_58_5);
    this._text_59 = this.renderer.createText(this._el_54,'\n                                        ',(null as any));
    this._text_60 = this.renderer.createText(this._el_6,'\n                                    ',(null as any));
    this._text_61 = this.renderer.createText(this._el_4,'\n                                ',(null as any));
    this._text_62 = this.renderer.createText((null as any),'\n                            ',(null as any));
    this.compView_2.create(this._CarTemplateListCardComponent_2_3.context);
    this._text_63 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray4(4,'edit',(null as any),'remove',(null as any)),this.eventHandler(this.handleEvent_2));
    this._CarTemplateListCardComponent_2_3.subscribe(this,this.eventHandler(this.handleEvent_2),true,true);
    this._pipe_translate_0 = new import17.TranslatePipe(this.parentView.injectorGet(import20.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_1 = new import17.TranslatePipe(this.parentView.injectorGet(import20.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_2 = new import17.TranslatePipe(this.parentView.injectorGet(import20.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_3 = new import17.TranslatePipe(this.parentView.injectorGet(import20.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_4 = new import17.TranslatePipe(this.parentView.injectorGet(import20.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_5 = new import17.TranslatePipe(this.parentView.injectorGet(import20.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_6 = new import17.TranslatePipe(this.parentView.injectorGet(import20.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_7 = new import17.TranslatePipe(this.parentView.injectorGet(import20.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_8 = new import17.TranslatePipe(this.parentView.injectorGet(import20.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_9 = new import17.TranslatePipe(this.parentView.injectorGet(import20.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._el_11,
      this._text_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._el_16,
      this._text_17,
      this._text_18,
      this._text_19,
      this._el_20,
      this._el_21,
      this._text_22,
      this._text_23,
      this._text_24,
      this._el_25,
      this._el_26,
      this._text_27,
      this._text_28,
      this._text_29,
      this._text_30,
      this._el_31,
      this._text_32,
      this._el_33,
      this._el_34,
      this._text_35,
      this._text_36,
      this._text_37,
      this._el_38,
      this._el_39,
      this._text_40,
      this._text_41,
      this._text_42,
      this._el_43,
      this._el_44,
      this._text_45,
      this._text_46,
      this._text_47,
      this._el_48,
      this._el_49,
      this._text_50,
      this._text_51,
      this._text_52,
      this._text_53,
      this._el_54,
      this._text_55,
      this._anchor_56,
      this._text_57,
      this._anchor_58,
      this._text_59,
      this._text_60,
      this._text_61,
      this._text_62,
      this._text_63
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import28.TemplateRef) && (56 === requestNodeIndex))) { return this._TemplateRef_56_5; }
    if (((token === import29.NgIf) && (56 === requestNodeIndex))) { return this._NgIf_56_6.context; }
    if (((token === import28.TemplateRef) && (58 === requestNodeIndex))) { return this._TemplateRef_58_5; }
    if (((token === import29.NgIf) && (58 === requestNodeIndex))) { return this._NgIf_58_6.context; }
    if (((token === import30.CarTemplateListCardComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 62)))) { return this._CarTemplateListCardComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import19.ValueUnwrapper();
    const currVal_2_0_0:any = this._map_72(((((this.context.$implicit.carModel == null)? (null as any): this.context.$implicit.carModel.brand) + '-') + ((this.context.$implicit.carModel == null)? (null as any): this.context.$implicit.carModel.model)),this.context.$implicit.approvalStatus,this.parentView.parentView.context.isEditable(this.context.$implicit),this.parentView.parentView.context.isRemovable(this.context.$implicit),false);
    this._CarTemplateListCardComponent_2_3.check_listCard(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = 150;
    this._CarTemplateListCardComponent_2_3.check_cardHeight(currVal_2_0_1,throwOnChange,false);
    this._CarTemplateListCardComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    const currVal_56_0_0:any = this.parentView.parentView.context.showAuxPicture(this.context.$implicit);
    this._NgIf_56_6.check_ngIf(currVal_56_0_0,throwOnChange,false);
    this._NgIf_56_6.ngDoCheck(this,this._anchor_56,throwOnChange);
    const currVal_58_0_0:boolean = !this.parentView.parentView.context.showAuxPicture(this.context.$implicit);
    this._NgIf_58_6.check_ngIf(currVal_58_0_0,throwOnChange,false);
    this._NgIf_58_6.ngDoCheck(this,this._anchor_58,throwOnChange);
    this._vc_56.detectChangesInNestedViews(throwOnChange);
    this._vc_58.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_73:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('carTemplate.BRAND')),':');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_73,currVal_73))) {
      this.renderer.setText(this._text_12,currVal_73);
      this._expr_73 = currVal_73;
    }
    const currVal_75:any = import3.inlineInterpolate(1,'',((this.context.$implicit.carModel == null)? (null as any): this.context.$implicit.carModel.brand),'');
    if (import3.checkBinding(throwOnChange,this._expr_75,currVal_75)) {
      this.renderer.setText(this._text_13,currVal_75);
      this._expr_75 = currVal_75;
    }
    valUnwrapper.reset();
    const currVal_76:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('carTemplate.MODEL')),':');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_76,currVal_76))) {
      this.renderer.setText(this._text_17,currVal_76);
      this._expr_76 = currVal_76;
    }
    const currVal_78:any = import3.inlineInterpolate(1,'',((this.context.$implicit.carModel == null)? (null as any): this.context.$implicit.carModel.model),'');
    if (import3.checkBinding(throwOnChange,this._expr_78,currVal_78)) {
      this.renderer.setText(this._text_18,currVal_78);
      this._expr_78 = currVal_78;
    }
    valUnwrapper.reset();
    const currVal_79:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('carTemplate.CATEGORY')),':');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_79,currVal_79))) {
      this.renderer.setText(this._text_22,currVal_79);
      this._expr_79 = currVal_79;
    }
    const currVal_81:any = import3.inlineInterpolate(1,'',((this.context.$implicit.carModel == null)? (null as any): this.context.$implicit.carModel.category),'');
    if (import3.checkBinding(throwOnChange,this._expr_81,currVal_81)) {
      this.renderer.setText(this._text_23,currVal_81);
      this._expr_81 = currVal_81;
    }
    valUnwrapper.reset();
    const currVal_82:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('carTemplate.TYPE')),':');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_82,currVal_82))) {
      this.renderer.setText(this._text_27,currVal_82);
      this._expr_82 = currVal_82;
    }
    const currVal_84:any = import3.inlineInterpolate(1,'',((this.context.$implicit.carModel == null)? (null as any): this.context.$implicit.carModel.type),'');
    if (import3.checkBinding(throwOnChange,this._expr_84,currVal_84)) {
      this.renderer.setText(this._text_28,currVal_84);
      this._expr_84 = currVal_84;
    }
    valUnwrapper.reset();
    const currVal_85:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_4.transform('carTemplate.DOORS')),':');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_85,currVal_85))) {
      this.renderer.setText(this._text_35,currVal_85);
      this._expr_85 = currVal_85;
    }
    const currVal_87:any = import3.inlineInterpolate(1,'',this.context.$implicit.doors,'');
    if (import3.checkBinding(throwOnChange,this._expr_87,currVal_87)) {
      this.renderer.setText(this._text_36,currVal_87);
      this._expr_87 = currVal_87;
    }
    valUnwrapper.reset();
    const currVal_88:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_5.transform('carTemplate.PASSENGERS')),':');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_88,currVal_88))) {
      this.renderer.setText(this._text_40,currVal_88);
      this._expr_88 = currVal_88;
    }
    const currVal_90:any = import3.inlineInterpolate(1,'',this.context.$implicit.passengers,'');
    if (import3.checkBinding(throwOnChange,this._expr_90,currVal_90)) {
      this.renderer.setText(this._text_41,currVal_90);
      this._expr_90 = currVal_90;
    }
    valUnwrapper.reset();
    const currVal_91:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_6.transform('carTemplate.AC')),':');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_91,currVal_91))) {
      this.renderer.setText(this._text_45,currVal_91);
      this._expr_91 = currVal_91;
    }
    valUnwrapper.reset();
    const currVal_93:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_7.transform(('common.' + this.context.$implicit.airConditioning))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_93,currVal_93))) {
      this.renderer.setText(this._text_46,currVal_93);
      this._expr_93 = currVal_93;
    }
    valUnwrapper.reset();
    const currVal_95:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_8.transform('carTemplate.TRANSMISSION')),':');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_95,currVal_95))) {
      this.renderer.setText(this._text_50,currVal_95);
      this._expr_95 = currVal_95;
    }
    valUnwrapper.reset();
    const currVal_97:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_9.transform(('fleet.TRANS_' + this.context.$implicit.transmission))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_97,currVal_97))) {
      this.renderer.setText(this._text_51,currVal_97);
      this._expr_97 = currVal_97;
    }
    this.compView_2.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { this._CarTemplateListCardComponent_2_3.context.ngAfterViewChecked(); }
  }
  destroyInternal():void {
    this._vc_56.destroyNestedViews();
    this._vc_58.destroyNestedViews();
    this.compView_2.destroy();
    this._CarTemplateListCardComponent_2_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
    this._pipe_translate_8.ngOnDestroy();
    this._pipe_translate_9.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  visitProjectableNodesInternal(nodeIndex:number,ngContentIndex:number,cb:any,ctx:any):void {
    if (((nodeIndex == 2) && (ngContentIndex == 0))) {
      cb(this._text_3,ctx);
      cb(this._el_4,ctx);
      cb(this._text_62,ctx);
    }
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 56)) { return new View_CarTemplateListComponent7(this.viewUtils,this,56,this._anchor_56,this._vc_56); }
    if ((nodeIndex == 58)) { return new View_CarTemplateListComponent9(this.viewUtils,this,58,this._anchor_58,this._vc_58); }
    return (null as any);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'edit')) {
      const pd_sub_0:any = ((<any>this.parentView.parentView.context.edit(this.context.$implicit.oid)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'remove')) {
      const pd_sub_1:any = ((<any>this.parentView.parentView.context.remove(this.context.$implicit.oid)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}
class View_CarTemplateListComponent5 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import18.ViewContainer;
  _TemplateRef_2_5:any;
  _NgFor_2_6:import32.Wrapper_NgFor;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  compView_6:import1.AppView<import33.EvaPagerComponent>;
  _EvaPagerComponent_6_3:import34.Wrapper_EvaPagerComponent;
  _text_7:any;
  _text_8:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import18.ViewContainer) {
    super(View_CarTemplateListComponent5,renderType_CarTemplateListComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import18.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import28.TemplateRef_(this,2,this._anchor_2);
    this._NgFor_2_6 = new import32.Wrapper_NgFor(this._vc_2.vcRef,this._TemplateRef_2_5,this.parentView.parentView.injectorGet(import35.IterableDiffers,this.parentView.parentIndex),this.parentView.ref);
    this._text_3 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-row -m-top-lg'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'eva-pager',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_6 = new import34.View_EvaPagerComponent0(this.viewUtils,this,6,this._el_6);
    this._EvaPagerComponent_6_3 = new import34.Wrapper_EvaPagerComponent();
    this.compView_6.create(this._EvaPagerComponent_6_3.context);
    this._text_7 = this.renderer.createText(this._el_4,'\n                        ',(null as any));
    this._text_8 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_6,new import3.InlineArray2(2,'pageChanged',(null as any)),this.eventHandler(this.handleEvent_6));
    this._EvaPagerComponent_6_3.subscribe(this,this.eventHandler(this.handleEvent_6),true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import28.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import36.NgFor) && (2 === requestNodeIndex))) { return this._NgFor_2_6.context; }
    if (((token === import33.EvaPagerComponent) && (6 === requestNodeIndex))) { return this._EvaPagerComponent_6_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.context.page.pageItems;
    this._NgFor_2_6.check_ngForOf(currVal_2_0_0,throwOnChange,false);
    this._NgFor_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    const currVal_6_0_0:any = this.parentView.context.page;
    this._EvaPagerComponent_6_3.check_config(currVal_6_0_0,throwOnChange,false);
    this._EvaPagerComponent_6_3.ngDoCheck(this,this._el_6,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
    this.compView_6.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
    this.compView_6.destroy();
    this._EvaPagerComponent_6_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 2)) { return new View_CarTemplateListComponent6(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    return (null as any);
  }
  handleEvent_6(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'pageChanged')) {
      const pd_sub_0:any = ((<any>this.parentView.context.onChangePage($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_CarTemplateListComponent11 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  /*private*/ _expr_13:any;
  _pipe_translate_0:import17.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import18.ViewContainer) {
    super(View_CarTemplateListComponent11,renderType_CarTemplateListComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_13 = import19.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mb-xlg empty-state-rate'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray4(4,'class','empty-state-image col -sm-12','qadata','emptyState'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','heading-example col -sm-12'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                                ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'img',new import3.InlineArray2(2,'src','assets/noresults-image.png'),(null as any));
    this._text_7 = this.renderer.createText(this._el_4,'\n                                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_4,'h3',new import3.InlineArray2(2,'class','eva-3-h3'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'',(null as any));
    this._text_10 = this.renderer.createText(this._el_4,'\n                            ',(null as any));
    this._text_11 = this.renderer.createText(this._el_2,'\n                        ',(null as any));
    this._text_12 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._pipe_translate_0 = new import17.TranslatePipe(this.parentView.injectorGet(import20.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._text_11,
      this._text_12
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import19.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_13:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('common.NO_RESULTS_FOUND')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_13,currVal_13))) {
      this.renderer.setText(this._text_9,currVal_13);
      this._expr_13 = currVal_13;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
var renderType_CarTemplateListComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_CarTemplateListComponent,{});
export class View_CarTemplateListComponent0 extends import1.AppView<import0.CarTemplateListComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _text_17:any;
  _text_18:any;
  _anchor_19:any;
  /*private*/ _vc_19:import18.ViewContainer;
  _TemplateRef_19_5:any;
  _NgIf_19_6:import27.Wrapper_NgIf;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _el_23:any;
  _text_24:any;
  _el_25:any;
  _text_26:any;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _el_30:any;
  _text_31:any;
  _el_32:any;
  _text_33:any;
  _el_34:any;
  _text_35:any;
  _text_36:any;
  _el_37:any;
  _text_38:any;
  _el_39:any;
  _SelectControlValueAccessor_39_3:import21.Wrapper_SelectControlValueAccessor;
  _NG_VALUE_ACCESSOR_39_4:any[];
  _NgModel_39_5:import37.Wrapper_NgModel;
  _NgControl_39_6:any;
  _NgControlStatus_39_7:import38.Wrapper_NgControlStatus;
  _text_40:any;
  _anchor_41:any;
  /*private*/ _vc_41:import18.ViewContainer;
  _TemplateRef_41_5:any;
  _NgFor_41_6:import32.Wrapper_NgFor;
  _text_42:any;
  _text_43:any;
  _text_44:any;
  _text_45:any;
  _text_46:any;
  _el_47:any;
  _text_48:any;
  _el_49:any;
  _text_50:any;
  _el_51:any;
  _text_52:any;
  _text_53:any;
  _el_54:any;
  _text_55:any;
  _el_56:any;
  _SelectControlValueAccessor_56_3:import21.Wrapper_SelectControlValueAccessor;
  _NG_VALUE_ACCESSOR_56_4:any[];
  _NgModel_56_5:import37.Wrapper_NgModel;
  _NgControl_56_6:any;
  _NgControlStatus_56_7:import38.Wrapper_NgControlStatus;
  _text_57:any;
  _el_58:any;
  _NgSelectOption_58_3:import21.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_58_4:import22.Wrapper_NgSelectMultipleOption;
  _text_59:any;
  _text_60:any;
  _anchor_61:any;
  /*private*/ _vc_61:import18.ViewContainer;
  _TemplateRef_61_5:any;
  _NgFor_61_6:import32.Wrapper_NgFor;
  _text_62:any;
  _text_63:any;
  _text_64:any;
  _text_65:any;
  _text_66:any;
  _el_67:any;
  _text_68:any;
  _el_69:any;
  _text_70:any;
  _el_71:any;
  _text_72:any;
  _text_73:any;
  _el_74:any;
  _text_75:any;
  _el_76:any;
  _SelectControlValueAccessor_76_3:import21.Wrapper_SelectControlValueAccessor;
  _NG_VALUE_ACCESSOR_76_4:any[];
  _NgModel_76_5:import37.Wrapper_NgModel;
  _NgControl_76_6:any;
  _NgControlStatus_76_7:import38.Wrapper_NgControlStatus;
  _text_77:any;
  _el_78:any;
  _NgSelectOption_78_3:import21.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_78_4:import22.Wrapper_NgSelectMultipleOption;
  _text_79:any;
  _text_80:any;
  _anchor_81:any;
  /*private*/ _vc_81:import18.ViewContainer;
  _TemplateRef_81_5:any;
  _NgFor_81_6:import32.Wrapper_NgFor;
  _text_82:any;
  _text_83:any;
  _text_84:any;
  _text_85:any;
  _text_86:any;
  _text_87:any;
  _text_88:any;
  _text_89:any;
  _el_90:any;
  _text_91:any;
  _anchor_92:any;
  /*private*/ _vc_92:import18.ViewContainer;
  _TemplateRef_92_5:any;
  _NgIf_92_6:import27.Wrapper_NgIf;
  _text_93:any;
  _anchor_94:any;
  /*private*/ _vc_94:import18.ViewContainer;
  _TemplateRef_94_5:any;
  _NgIf_94_6:import27.Wrapper_NgIf;
  _text_95:any;
  _text_96:any;
  _text_97:any;
  _text_98:any;
  _text_99:any;
  /*private*/ _expr_137:any;
  _pipe_translate_0:import17.TranslatePipe;
  /*private*/ _expr_139:any;
  _pipe_translate_1:import17.TranslatePipe;
  /*private*/ _expr_141:any;
  _pipe_translate_2:import17.TranslatePipe;
  /*private*/ _expr_143:any;
  _pipe_translate_3:import17.TranslatePipe;
  /*private*/ _expr_145:any;
  _pipe_translate_4:import17.TranslatePipe;
  /*private*/ _expr_147:any;
  _pipe_translate_5:import17.TranslatePipe;
  /*private*/ _expr_149:any;
  _pipe_translate_6:import17.TranslatePipe;
  /*private*/ _expr_151:any;
  _pipe_translate_7:import17.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_CarTemplateListComponent0,renderType_CarTemplateListComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_137 = import19.UNINITIALIZED;
    this._expr_139 = import19.UNINITIALIZED;
    this._expr_141 = import19.UNINITIALIZED;
    this._expr_143 = import19.UNINITIALIZED;
    this._expr_145 = import19.UNINITIALIZED;
    this._expr_147 = import19.UNINITIALIZED;
    this._expr_149 = import19.UNINITIALIZED;
    this._expr_151 = import19.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-slide -up -start'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','container-fluid whitesmoke-section'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-container'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','eva-grid'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mb-lg'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'span',new import3.InlineArray2(2,'class','-h2 -eva-3-ml-xsm'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'',(null as any));
    this._text_14 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_10,'p',new import3.InlineArray4(4,'class','-h6 -eva-3-tc-gray-2 -eva-3-mt-sm -eva-3-ml-xsm','style','line-height: 16px;'),(null as any));
    this._text_16 = this.renderer.createText(this._el_10,'\n                    ',(null as any));
    this._text_17 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._text_18 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._anchor_19 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._vc_19 = new import18.ViewContainer(19,6,this,this._anchor_19);
    this._TemplateRef_19_5 = new import28.TemplateRef_(this,19,this._anchor_19);
    this._NgIf_19_6 = new import27.Wrapper_NgIf(this._vc_19.vcRef,this._TemplateRef_19_5);
    this._text_20 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray4(4,'class','eva-3-row -eva-3-mt-lg','qadata','page_actions'),(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'\n                    ',(null as any));
    this._el_23 = import3.createRenderElement(this.renderer,this._el_21,'div',new import3.InlineArray2(2,'class','white-container reset-styles'),(null as any));
    this._text_24 = this.renderer.createText(this._el_23,'\n                        ',(null as any));
    this._el_25 = import3.createRenderElement(this.renderer,this._el_23,'h4',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_26 = this.renderer.createText(this._el_25,'',(null as any));
    this._text_27 = this.renderer.createText(this._el_23,'\n                        ',(null as any));
    this._el_28 = import3.createRenderElement(this.renderer,this._el_23,'div',new import3.InlineArray2(2,'class','eva-row'),(null as any));
    this._text_29 = this.renderer.createText(this._el_28,'\n                            ',(null as any));
    this._el_30 = import3.createRenderElement(this.renderer,this._el_28,'div',new import3.InlineArray2(2,'class','col -md-3'),(null as any));
    this._text_31 = this.renderer.createText(this._el_30,'\n                                ',(null as any));
    this._el_32 = import3.createRenderElement(this.renderer,this._el_30,'div',new import3.InlineArray2(2,'class','eva-select -md'),(null as any));
    this._text_33 = this.renderer.createText(this._el_32,'\n                                    ',(null as any));
    this._el_34 = import3.createRenderElement(this.renderer,this._el_32,'label',new import3.InlineArray2(2,'for','select-specialoffer-type'),(null as any));
    this._text_35 = this.renderer.createText(this._el_34,'',(null as any));
    this._text_36 = this.renderer.createText(this._el_32,'\n                                    ',(null as any));
    this._el_37 = import3.createRenderElement(this.renderer,this._el_32,'div',new import3.InlineArray2(2,'class','select-container'),(null as any));
    this._text_38 = this.renderer.createText(this._el_37,'\n                                        ',(null as any));
    this._el_39 = import3.createRenderElement(this.renderer,this._el_37,'select',new import3.InlineArray2(2,'class','select-tag'),(null as any));
    this._SelectControlValueAccessor_39_3 = new import21.Wrapper_SelectControlValueAccessor(this.renderer,new import23.ElementRef(this._el_39));
    this._NG_VALUE_ACCESSOR_39_4 = [this._SelectControlValueAccessor_39_3.context];
    this._NgModel_39_5 = new import37.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_39_4);
    this._NgControl_39_6 = this._NgModel_39_5.context;
    this._NgControlStatus_39_7 = new import38.Wrapper_NgControlStatus(this._NgControl_39_6);
    this._text_40 = this.renderer.createText(this._el_39,'\n                                            ',(null as any));
    this._anchor_41 = this.renderer.createTemplateAnchor(this._el_39,(null as any));
    this._vc_41 = new import18.ViewContainer(41,39,this,this._anchor_41);
    this._TemplateRef_41_5 = new import28.TemplateRef_(this,41,this._anchor_41);
    this._NgFor_41_6 = new import32.Wrapper_NgFor(this._vc_41.vcRef,this._TemplateRef_41_5,this.parentView.injectorGet(import35.IterableDiffers,this.parentIndex),this.ref);
    this._text_42 = this.renderer.createText(this._el_39,'\n                                        ',(null as any));
    this._text_43 = this.renderer.createText(this._el_37,'\n                                    ',(null as any));
    this._text_44 = this.renderer.createText(this._el_32,'\n                                ',(null as any));
    this._text_45 = this.renderer.createText(this._el_30,'\n                            ',(null as any));
    this._text_46 = this.renderer.createText(this._el_28,'\n                            ',(null as any));
    this._el_47 = import3.createRenderElement(this.renderer,this._el_28,'div',new import3.InlineArray2(2,'class','col -md-3'),(null as any));
    this._text_48 = this.renderer.createText(this._el_47,'\n                                ',(null as any));
    this._el_49 = import3.createRenderElement(this.renderer,this._el_47,'div',new import3.InlineArray2(2,'class','eva-select -md'),(null as any));
    this._text_50 = this.renderer.createText(this._el_49,'\n                                    ',(null as any));
    this._el_51 = import3.createRenderElement(this.renderer,this._el_49,'label',new import3.InlineArray2(2,'for','select-specialoffer-type'),(null as any));
    this._text_52 = this.renderer.createText(this._el_51,'',(null as any));
    this._text_53 = this.renderer.createText(this._el_49,'\n                                    ',(null as any));
    this._el_54 = import3.createRenderElement(this.renderer,this._el_49,'div',new import3.InlineArray2(2,'class','select-container'),(null as any));
    this._text_55 = this.renderer.createText(this._el_54,'\n                                        ',(null as any));
    this._el_56 = import3.createRenderElement(this.renderer,this._el_54,'select',new import3.InlineArray2(2,'class','select-tag'),(null as any));
    this._SelectControlValueAccessor_56_3 = new import21.Wrapper_SelectControlValueAccessor(this.renderer,new import23.ElementRef(this._el_56));
    this._NG_VALUE_ACCESSOR_56_4 = [this._SelectControlValueAccessor_56_3.context];
    this._NgModel_56_5 = new import37.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_56_4);
    this._NgControl_56_6 = this._NgModel_56_5.context;
    this._NgControlStatus_56_7 = new import38.Wrapper_NgControlStatus(this._NgControl_56_6);
    this._text_57 = this.renderer.createText(this._el_56,'\n                                            ',(null as any));
    this._el_58 = import3.createRenderElement(this.renderer,this._el_56,'option',new import3.InlineArray2(2,'value',''),(null as any));
    this._NgSelectOption_58_3 = new import21.Wrapper_NgSelectOption(new import23.ElementRef(this._el_58),this.renderer,this._SelectControlValueAccessor_56_3.context);
    this._NgSelectMultipleOption_58_4 = new import22.Wrapper_NgSelectMultipleOption(new import23.ElementRef(this._el_58),this.renderer,(null as any));
    this._text_59 = this.renderer.createText(this._el_58,'',(null as any));
    this._text_60 = this.renderer.createText(this._el_56,'\n                                            ',(null as any));
    this._anchor_61 = this.renderer.createTemplateAnchor(this._el_56,(null as any));
    this._vc_61 = new import18.ViewContainer(61,56,this,this._anchor_61);
    this._TemplateRef_61_5 = new import28.TemplateRef_(this,61,this._anchor_61);
    this._NgFor_61_6 = new import32.Wrapper_NgFor(this._vc_61.vcRef,this._TemplateRef_61_5,this.parentView.injectorGet(import35.IterableDiffers,this.parentIndex),this.ref);
    this._text_62 = this.renderer.createText(this._el_56,'\n                                        ',(null as any));
    this._text_63 = this.renderer.createText(this._el_54,'\n                                    ',(null as any));
    this._text_64 = this.renderer.createText(this._el_49,'\n                                ',(null as any));
    this._text_65 = this.renderer.createText(this._el_47,'\n                            ',(null as any));
    this._text_66 = this.renderer.createText(this._el_28,'\n                            ',(null as any));
    this._el_67 = import3.createRenderElement(this.renderer,this._el_28,'div',new import3.InlineArray2(2,'class','col -md-3'),(null as any));
    this._text_68 = this.renderer.createText(this._el_67,'\n                                ',(null as any));
    this._el_69 = import3.createRenderElement(this.renderer,this._el_67,'div',new import3.InlineArray2(2,'class','eva-select -md'),(null as any));
    this._text_70 = this.renderer.createText(this._el_69,'\n                                    ',(null as any));
    this._el_71 = import3.createRenderElement(this.renderer,this._el_69,'label',new import3.InlineArray2(2,'for','select-specialoffer-type'),(null as any));
    this._text_72 = this.renderer.createText(this._el_71,'',(null as any));
    this._text_73 = this.renderer.createText(this._el_69,'\n                                    ',(null as any));
    this._el_74 = import3.createRenderElement(this.renderer,this._el_69,'div',new import3.InlineArray2(2,'class','select-container'),(null as any));
    this._text_75 = this.renderer.createText(this._el_74,'\n                                        ',(null as any));
    this._el_76 = import3.createRenderElement(this.renderer,this._el_74,'select',new import3.InlineArray4(4,'class','select-tag','id','select-specialoffer-type'),(null as any));
    this._SelectControlValueAccessor_76_3 = new import21.Wrapper_SelectControlValueAccessor(this.renderer,new import23.ElementRef(this._el_76));
    this._NG_VALUE_ACCESSOR_76_4 = [this._SelectControlValueAccessor_76_3.context];
    this._NgModel_76_5 = new import37.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_76_4);
    this._NgControl_76_6 = this._NgModel_76_5.context;
    this._NgControlStatus_76_7 = new import38.Wrapper_NgControlStatus(this._NgControl_76_6);
    this._text_77 = this.renderer.createText(this._el_76,'\n                                            ',(null as any));
    this._el_78 = import3.createRenderElement(this.renderer,this._el_76,'option',new import3.InlineArray2(2,'value',''),(null as any));
    this._NgSelectOption_78_3 = new import21.Wrapper_NgSelectOption(new import23.ElementRef(this._el_78),this.renderer,this._SelectControlValueAccessor_76_3.context);
    this._NgSelectMultipleOption_78_4 = new import22.Wrapper_NgSelectMultipleOption(new import23.ElementRef(this._el_78),this.renderer,(null as any));
    this._text_79 = this.renderer.createText(this._el_78,'',(null as any));
    this._text_80 = this.renderer.createText(this._el_76,'\n                                            ',(null as any));
    this._anchor_81 = this.renderer.createTemplateAnchor(this._el_76,(null as any));
    this._vc_81 = new import18.ViewContainer(81,76,this,this._anchor_81);
    this._TemplateRef_81_5 = new import28.TemplateRef_(this,81,this._anchor_81);
    this._NgFor_81_6 = new import32.Wrapper_NgFor(this._vc_81.vcRef,this._TemplateRef_81_5,this.parentView.injectorGet(import35.IterableDiffers,this.parentIndex),this.ref);
    this._text_82 = this.renderer.createText(this._el_76,'\n                                        ',(null as any));
    this._text_83 = this.renderer.createText(this._el_74,'\n                                    ',(null as any));
    this._text_84 = this.renderer.createText(this._el_69,'\n                                ',(null as any));
    this._text_85 = this.renderer.createText(this._el_67,'\n                            ',(null as any));
    this._text_86 = this.renderer.createText(this._el_28,'\n                        ',(null as any));
    this._text_87 = this.renderer.createText(this._el_23,'\n                    ',(null as any));
    this._text_88 = this.renderer.createText(this._el_21,'\n                ',(null as any));
    this._text_89 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_90 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','eva-row -m-top-lg'),(null as any));
    this._text_91 = this.renderer.createText(this._el_90,'\n                    ',(null as any));
    this._anchor_92 = this.renderer.createTemplateAnchor(this._el_90,(null as any));
    this._vc_92 = new import18.ViewContainer(92,90,this,this._anchor_92);
    this._TemplateRef_92_5 = new import28.TemplateRef_(this,92,this._anchor_92);
    this._NgIf_92_6 = new import27.Wrapper_NgIf(this._vc_92.vcRef,this._TemplateRef_92_5);
    this._text_93 = this.renderer.createText(this._el_90,'\n                    ',(null as any));
    this._anchor_94 = this.renderer.createTemplateAnchor(this._el_90,(null as any));
    this._vc_94 = new import18.ViewContainer(94,90,this,this._anchor_94);
    this._TemplateRef_94_5 = new import28.TemplateRef_(this,94,this._anchor_94);
    this._NgIf_94_6 = new import27.Wrapper_NgIf(this._vc_94.vcRef,this._TemplateRef_94_5);
    this._text_95 = this.renderer.createText(this._el_90,'\n                ',(null as any));
    this._text_96 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_97 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_98 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_99 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._pipe_translate_0 = new import17.TranslatePipe(this.parentView.injectorGet(import20.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import17.TranslatePipe(this.parentView.injectorGet(import20.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_2 = new import17.TranslatePipe(this.parentView.injectorGet(import20.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_3 = new import17.TranslatePipe(this.parentView.injectorGet(import20.TranslateService,this.parentIndex),this.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_39,new import3.InlineArray8(6,'change',(null as any),'ngModelChange',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_39));
    this._NgModel_39_5.subscribe(this,this.eventHandler(this.handleEvent_39),true);
    this._pipe_translate_4 = new import17.TranslatePipe(this.parentView.injectorGet(import20.TranslateService,this.parentIndex),this.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_56,new import3.InlineArray8(6,'change',(null as any),'ngModelChange',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_56));
    this._NgModel_56_5.subscribe(this,this.eventHandler(this.handleEvent_56),true);
    this._pipe_translate_5 = new import17.TranslatePipe(this.parentView.injectorGet(import20.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_6 = new import17.TranslatePipe(this.parentView.injectorGet(import20.TranslateService,this.parentIndex),this.ref);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_76,new import3.InlineArray8(6,'change',(null as any),'ngModelChange',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_76));
    this._NgModel_76_5.subscribe(this,this.eventHandler(this.handleEvent_76),true);
    this._pipe_translate_7 = new import17.TranslatePipe(this.parentView.injectorGet(import20.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._text_18,
      this._anchor_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._el_25,
      this._text_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._el_30,
      this._text_31,
      this._el_32,
      this._text_33,
      this._el_34,
      this._text_35,
      this._text_36,
      this._el_37,
      this._text_38,
      this._el_39,
      this._text_40,
      this._anchor_41,
      this._text_42,
      this._text_43,
      this._text_44,
      this._text_45,
      this._text_46,
      this._el_47,
      this._text_48,
      this._el_49,
      this._text_50,
      this._el_51,
      this._text_52,
      this._text_53,
      this._el_54,
      this._text_55,
      this._el_56,
      this._text_57,
      this._el_58,
      this._text_59,
      this._text_60,
      this._anchor_61,
      this._text_62,
      this._text_63,
      this._text_64,
      this._text_65,
      this._text_66,
      this._el_67,
      this._text_68,
      this._el_69,
      this._text_70,
      this._el_71,
      this._text_72,
      this._text_73,
      this._el_74,
      this._text_75,
      this._el_76,
      this._text_77,
      this._el_78,
      this._text_79,
      this._text_80,
      this._anchor_81,
      this._text_82,
      this._text_83,
      this._text_84,
      this._text_85,
      this._text_86,
      this._text_87,
      this._text_88,
      this._text_89,
      this._el_90,
      this._text_91,
      this._anchor_92,
      this._text_93,
      this._anchor_94,
      this._text_95,
      this._text_96,
      this._text_97,
      this._text_98,
      this._text_99
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import28.TemplateRef) && (19 === requestNodeIndex))) { return this._TemplateRef_19_5; }
    if (((token === import29.NgIf) && (19 === requestNodeIndex))) { return this._NgIf_19_6.context; }
    if (((token === import28.TemplateRef) && (41 === requestNodeIndex))) { return this._TemplateRef_41_5; }
    if (((token === import36.NgFor) && (41 === requestNodeIndex))) { return this._NgFor_41_6.context; }
    if (((token === import24.SelectControlValueAccessor) && ((39 <= requestNodeIndex) && (requestNodeIndex <= 42)))) { return this._SelectControlValueAccessor_39_3.context; }
    if (((token === import39.NG_VALUE_ACCESSOR) && ((39 <= requestNodeIndex) && (requestNodeIndex <= 42)))) { return this._NG_VALUE_ACCESSOR_39_4; }
    if (((token === import40.NgModel) && ((39 <= requestNodeIndex) && (requestNodeIndex <= 42)))) { return this._NgModel_39_5.context; }
    if (((token === import41.NgControl) && ((39 <= requestNodeIndex) && (requestNodeIndex <= 42)))) { return this._NgControl_39_6; }
    if (((token === import42.NgControlStatus) && ((39 <= requestNodeIndex) && (requestNodeIndex <= 42)))) { return this._NgControlStatus_39_7.context; }
    if (((token === import24.NgSelectOption) && ((58 <= requestNodeIndex) && (requestNodeIndex <= 59)))) { return this._NgSelectOption_58_3.context; }
    if (((token === import25.NgSelectMultipleOption) && ((58 <= requestNodeIndex) && (requestNodeIndex <= 59)))) { return this._NgSelectMultipleOption_58_4.context; }
    if (((token === import28.TemplateRef) && (61 === requestNodeIndex))) { return this._TemplateRef_61_5; }
    if (((token === import36.NgFor) && (61 === requestNodeIndex))) { return this._NgFor_61_6.context; }
    if (((token === import24.SelectControlValueAccessor) && ((56 <= requestNodeIndex) && (requestNodeIndex <= 62)))) { return this._SelectControlValueAccessor_56_3.context; }
    if (((token === import39.NG_VALUE_ACCESSOR) && ((56 <= requestNodeIndex) && (requestNodeIndex <= 62)))) { return this._NG_VALUE_ACCESSOR_56_4; }
    if (((token === import40.NgModel) && ((56 <= requestNodeIndex) && (requestNodeIndex <= 62)))) { return this._NgModel_56_5.context; }
    if (((token === import41.NgControl) && ((56 <= requestNodeIndex) && (requestNodeIndex <= 62)))) { return this._NgControl_56_6; }
    if (((token === import42.NgControlStatus) && ((56 <= requestNodeIndex) && (requestNodeIndex <= 62)))) { return this._NgControlStatus_56_7.context; }
    if (((token === import24.NgSelectOption) && ((78 <= requestNodeIndex) && (requestNodeIndex <= 79)))) { return this._NgSelectOption_78_3.context; }
    if (((token === import25.NgSelectMultipleOption) && ((78 <= requestNodeIndex) && (requestNodeIndex <= 79)))) { return this._NgSelectMultipleOption_78_4.context; }
    if (((token === import28.TemplateRef) && (81 === requestNodeIndex))) { return this._TemplateRef_81_5; }
    if (((token === import36.NgFor) && (81 === requestNodeIndex))) { return this._NgFor_81_6.context; }
    if (((token === import24.SelectControlValueAccessor) && ((76 <= requestNodeIndex) && (requestNodeIndex <= 82)))) { return this._SelectControlValueAccessor_76_3.context; }
    if (((token === import39.NG_VALUE_ACCESSOR) && ((76 <= requestNodeIndex) && (requestNodeIndex <= 82)))) { return this._NG_VALUE_ACCESSOR_76_4; }
    if (((token === import40.NgModel) && ((76 <= requestNodeIndex) && (requestNodeIndex <= 82)))) { return this._NgModel_76_5.context; }
    if (((token === import41.NgControl) && ((76 <= requestNodeIndex) && (requestNodeIndex <= 82)))) { return this._NgControl_76_6; }
    if (((token === import42.NgControlStatus) && ((76 <= requestNodeIndex) && (requestNodeIndex <= 82)))) { return this._NgControlStatus_76_7.context; }
    if (((token === import28.TemplateRef) && (92 === requestNodeIndex))) { return this._TemplateRef_92_5; }
    if (((token === import29.NgIf) && (92 === requestNodeIndex))) { return this._NgIf_92_6.context; }
    if (((token === import28.TemplateRef) && (94 === requestNodeIndex))) { return this._TemplateRef_94_5; }
    if (((token === import29.NgIf) && (94 === requestNodeIndex))) { return this._NgIf_94_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import19.ValueUnwrapper();
    const currVal_19_0_0:any = this.context.canCreate();
    this._NgIf_19_6.check_ngIf(currVal_19_0_0,throwOnChange,false);
    this._NgIf_19_6.ngDoCheck(this,this._anchor_19,throwOnChange);
    this._SelectControlValueAccessor_39_3.ngDoCheck(this,this._el_39,throwOnChange);
    const currVal_39_1_0:any = this.context.carTemplateFilter.approvalStatus;
    this._NgModel_39_5.check_model(currVal_39_1_0,throwOnChange,false);
    this._NgModel_39_5.ngDoCheck(this,this._el_39,throwOnChange);
    this._NgControlStatus_39_7.ngDoCheck(this,this._el_39,throwOnChange);
    const currVal_41_0_0:any = this.context.approvalStatus;
    this._NgFor_41_6.check_ngForOf(currVal_41_0_0,throwOnChange,false);
    this._NgFor_41_6.ngDoCheck(this,this._anchor_41,throwOnChange);
    this._SelectControlValueAccessor_56_3.ngDoCheck(this,this._el_56,throwOnChange);
    const currVal_56_1_0:any = this.context.carTemplateFilter.brand;
    this._NgModel_56_5.check_model(currVal_56_1_0,throwOnChange,false);
    this._NgModel_56_5.ngDoCheck(this,this._el_56,throwOnChange);
    this._NgControlStatus_56_7.ngDoCheck(this,this._el_56,throwOnChange);
    const currVal_58_0_0:any = '';
    this._NgSelectOption_58_3.check_value(currVal_58_0_0,throwOnChange,false);
    this._NgSelectOption_58_3.ngDoCheck(this,this._el_58,throwOnChange);
    const currVal_58_1_0:any = '';
    this._NgSelectMultipleOption_58_4.check_value(currVal_58_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_58_4.ngDoCheck(this,this._el_58,throwOnChange);
    const currVal_61_0_0:any = this.context.brands;
    this._NgFor_61_6.check_ngForOf(currVal_61_0_0,throwOnChange,false);
    this._NgFor_61_6.ngDoCheck(this,this._anchor_61,throwOnChange);
    this._SelectControlValueAccessor_76_3.ngDoCheck(this,this._el_76,throwOnChange);
    const currVal_76_1_0:any = this.context.carTemplateFilter.model;
    this._NgModel_76_5.check_model(currVal_76_1_0,throwOnChange,false);
    this._NgModel_76_5.ngDoCheck(this,this._el_76,throwOnChange);
    this._NgControlStatus_76_7.ngDoCheck(this,this._el_76,throwOnChange);
    const currVal_78_0_0:any = '';
    this._NgSelectOption_78_3.check_value(currVal_78_0_0,throwOnChange,false);
    this._NgSelectOption_78_3.ngDoCheck(this,this._el_78,throwOnChange);
    const currVal_78_1_0:any = '';
    this._NgSelectMultipleOption_78_4.check_value(currVal_78_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_78_4.ngDoCheck(this,this._el_78,throwOnChange);
    const currVal_81_0_0:any = this.context.models;
    this._NgFor_81_6.check_ngForOf(currVal_81_0_0,throwOnChange,false);
    this._NgFor_81_6.ngDoCheck(this,this._anchor_81,throwOnChange);
    const currVal_92_0_0:boolean = (!this.context.isLoading() && !!((this.context.page == null)? (null as any): this.context.page.pageItems));
    this._NgIf_92_6.check_ngIf(currVal_92_0_0,throwOnChange,false);
    this._NgIf_92_6.ngDoCheck(this,this._anchor_92,throwOnChange);
    const currVal_94_0_0:boolean = ((!this.context.isLoading() && !!((this.context.page == null)? (null as any): this.context.page.pageItems)) && (this.context.page.pageItems.length === 0));
    this._NgIf_94_6.check_ngIf(currVal_94_0_0,throwOnChange,false);
    this._NgIf_94_6.ngDoCheck(this,this._anchor_94,throwOnChange);
    this._vc_19.detectChangesInNestedViews(throwOnChange);
    this._vc_41.detectChangesInNestedViews(throwOnChange);
    this._vc_61.detectChangesInNestedViews(throwOnChange);
    this._vc_81.detectChangesInNestedViews(throwOnChange);
    this._vc_92.detectChangesInNestedViews(throwOnChange);
    this._vc_94.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_137:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('carTemplate.TITLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_137,currVal_137))) {
      this.renderer.setText(this._text_13,currVal_137);
      this._expr_137 = currVal_137;
    }
    valUnwrapper.reset();
    const currVal_139:any = valUnwrapper.unwrap(this._pipe_translate_1.transform('carTemplate.SUBTITLE'));
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_139,currVal_139))) {
      this.renderer.setElementProperty(this._el_15,'innerHTML',this.viewUtils.sanitizer.sanitize(import26.SecurityContext.HTML,currVal_139));
      this._expr_139 = currVal_139;
    }
    valUnwrapper.reset();
    const currVal_141:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('specialOffers.list.filters.title')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_141,currVal_141))) {
      this.renderer.setText(this._text_26,currVal_141);
      this._expr_141 = currVal_141;
    }
    valUnwrapper.reset();
    const currVal_143:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('carTemplate.APPROVAL_STATUS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_143,currVal_143))) {
      this.renderer.setText(this._text_35,currVal_143);
      this._expr_143 = currVal_143;
    }
    this._NgControlStatus_39_7.checkHost(this,this,this._el_39,throwOnChange);
    valUnwrapper.reset();
    const currVal_145:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_4.transform('carTemplate.BRAND')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_145,currVal_145))) {
      this.renderer.setText(this._text_52,currVal_145);
      this._expr_145 = currVal_145;
    }
    this._NgControlStatus_56_7.checkHost(this,this,this._el_56,throwOnChange);
    valUnwrapper.reset();
    const currVal_147:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_5.transform('common.ALL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_147,currVal_147))) {
      this.renderer.setText(this._text_59,currVal_147);
      this._expr_147 = currVal_147;
    }
    valUnwrapper.reset();
    const currVal_149:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_6.transform('carTemplate.MODEL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_149,currVal_149))) {
      this.renderer.setText(this._text_72,currVal_149);
      this._expr_149 = currVal_149;
    }
    this._NgControlStatus_76_7.checkHost(this,this,this._el_76,throwOnChange);
    valUnwrapper.reset();
    const currVal_151:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_7.transform('common.ALL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_151,currVal_151))) {
      this.renderer.setText(this._text_79,currVal_151);
      this._expr_151 = currVal_151;
    }
  }
  destroyInternal():void {
    this._vc_19.destroyNestedViews();
    this._vc_41.destroyNestedViews();
    this._vc_61.destroyNestedViews();
    this._vc_81.destroyNestedViews();
    this._vc_92.destroyNestedViews();
    this._vc_94.destroyNestedViews();
    this._NgModel_39_5.ngOnDestroy();
    this._NgSelectOption_58_3.ngOnDestroy();
    this._NgSelectMultipleOption_58_4.ngOnDestroy();
    this._NgModel_56_5.ngOnDestroy();
    this._NgSelectOption_78_3.ngOnDestroy();
    this._NgSelectMultipleOption_78_4.ngOnDestroy();
    this._NgModel_76_5.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 19)) { return new View_CarTemplateListComponent1(this.viewUtils,this,19,this._anchor_19,this._vc_19); }
    if ((nodeIndex == 41)) { return new View_CarTemplateListComponent2(this.viewUtils,this,41,this._anchor_41,this._vc_41); }
    if ((nodeIndex == 61)) { return new View_CarTemplateListComponent3(this.viewUtils,this,61,this._anchor_61,this._vc_61); }
    if ((nodeIndex == 81)) { return new View_CarTemplateListComponent4(this.viewUtils,this,81,this._anchor_81,this._vc_81); }
    if ((nodeIndex == 92)) { return new View_CarTemplateListComponent5(this.viewUtils,this,92,this._anchor_92,this._vc_92); }
    if ((nodeIndex == 94)) { return new View_CarTemplateListComponent11(this.viewUtils,this,94,this._anchor_94,this._vc_94); }
    return (null as any);
  }
  handleEvent_39(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._SelectControlValueAccessor_39_3.handleEvent(eventName,$event) && result);
    if ((eventName == 'change')) {
      const pd_sub_0:any = ((<any>this.context.getCarTemplates()) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'ngModelChange')) {
      const pd_sub_1:any = ((<any>(this.context.carTemplateFilter.approvalStatus = $event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
  handleEvent_56(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._SelectControlValueAccessor_56_3.handleEvent(eventName,$event) && result);
    if ((eventName == 'change')) {
      const pd_sub_0:any = ((<any>this.context.onBrandChange()) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'ngModelChange')) {
      const pd_sub_1:any = ((<any>(this.context.carTemplateFilter.brand = $event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
  handleEvent_76(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._SelectControlValueAccessor_76_3.handleEvent(eventName,$event) && result);
    if ((eventName == 'change')) {
      const pd_sub_0:any = ((<any>this.context.getCarTemplates()) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'ngModelChange')) {
      const pd_sub_1:any = ((<any>(this.context.carTemplateFilter.model = $event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/carTemplate/list/car-template-list.component.ngfactory.ts